/**
 * OVERRIDE ImageSidebar.jsx
 * REASON: There are some specific behavior that we want to enforce to the sizes
 * and alignment settings
 */

import ImageSidebar from '../../../../../../components/Blocks/Image/ImageSidebar';

export default ImageSidebar;
